import { DistributionChannel } from '@avantstay/arriere-clients/dist/arriereBackoffice'

// Human-friendly label for every distribution channel. Some channels (BookingPal, Derbysoft,
// Streamline) have no matching OnlineTravelAgency value, so onlineTravelAgencyLabel can't cover
// them — hence this dedicated map. Typed as an exhaustive Record so new channels must be added.
export const distributionChannelLabel: Record<DistributionChannel, string> = {
  [DistributionChannel.airbnb]: 'Airbnb',
  [DistributionChannel.avantstay]: 'AvantStay',
  [DistributionChannel.bookingPal]: 'BookingPal',
  [DistributionChannel.derbysoft]: 'Derbysoft',
  [DistributionChannel.hotelTonight]: 'HotelTonight',
  [DistributionChannel.rentalsUnited]: 'Rentals United',
  [DistributionChannel.streamline]: 'Streamline',
  [DistributionChannel.vrbo]: 'VRBO',
  [DistributionChannel.yieldPlanet]: 'Yield Planet',
}
